import { Component, EventEmitter, Renderer2, TemplateRef, ViewChild, OnInit, Injectable, AfterContentInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faBook, faSearch, faTrowel, faHamburger, faAmbulance, faAnchorCircleCheck, faHome, faSquareEnvelope, faUser, faCircleQuestion, faSignOut, faMessage, faDedent } from "@fortawesome/free-solid-svg-icons";
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MsalService } from '@azure/msal-angular';
import { filter } from 'rxjs';
import { qmsService } from '../qms/qms.service';
import { PaginationService } from '../PaginationService';
import * as moment from 'moment';
import { OneQmsAuthService } from '../core/auth/one-qms-auth.service';

export interface oneQmsOrgImagesInterface {
  loginImage: Blob;
  loginImageExtn: Blob;
  logoImage: Blob;
  logoImageExt: Blob;
  loginpageContent: string;
  updateReason: string;
  createdByName: string;
  createdOn: Date;
  updatedByName: string;
  updatedOn: Date;
}
export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
@Injectable({
  providedIn: 'root'
})
export class DashboardComponent implements OnInit, AfterContentInit {

  isProcessing = false;
  userprofilename = localStorage.getItem("userprofilename");
  email = localStorage.getItem("email");

  isSidebarOpen = true;
  orgDetail: any = {};
  treeDataSource: any = [];
  isLoggedIn: boolean;
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  ngAfterContentInit() {
    if (this.message.clearcache) {
      this.isProcessing = true;
      // Clear message history when cache is cleared
      this.message.message = [];
      let returndata = this.appService.clearcache();
      if (returndata != null) { this.message.clearcache = false; this.isProcessing = false; }
    }
  }

  private readonly oneQmsChannel = new BroadcastChannel('one-qms-channel');
  constructor(private readonly authService: MsalService, public appService: AppService, private readonly router: Router, public SVC: messageService, public dialog: MatDialog,
    private readonly snackBar: MatSnackBar, public qmsservice: qmsService, public message: messageService,
    public activatedRoute: ActivatedRoute, public paginationService: PaginationService,
    private readonly renderer: Renderer2,
    private readonly oneQmsAuthService: OneQmsAuthService

  ) {
    this.oneQmsChannel.postMessage({ type: 'SESSION_REFRESH' });
    this.appService.getUserDetailsForTrainingDashboard().subscribe((user: any) => {
      sessionStorage.setItem("reportsUserName", user[0].userNameAtReports);
    })
    this.qmsservice.groupNameAndValue = [];
    this.authService.initialize();

    this.qmsservice.topNavModule = null;
    this.qmsservice.showTopNav = false;
    this.qmsservice.loggeduserid = this.message.getUserId();

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.SVC.organizationDetails = data;
      data?.isAllowMobileAccess == 'N' && this.detectDevice();
      if (this.SVC.organizationDetails.dateFormat.includes("MON")) {
        this.SVC.organizationDetails.dateFormat = this.SVC.organizationDetails.dateFormat.replace("MON", "MMM");
        document.documentElement.style.setProperty('--text-transform-update', 'uppercase');
      }
      if (this.SVC.organizationDetails.dateFormat.includes("Mon")) {
        this.SVC.organizationDetails.dateFormat = this.SVC.organizationDetails.dateFormat.replace("Mon", "Mmm");
        document.documentElement.style.setProperty('--text-transform-update', 'capitalize');
      }
      this.SVC.organizationDetails.htmlDateFormat = this.SVC.organizationDetails.dateFormat;
      this.SVC.organizationDetails.htmlDateFormat = this.SVC.organizationDetails.htmlDateFormat.replace("DD", "dd");
      this.SVC.organizationDetails = data;
      this.appService.organizationDetails = data;
      localStorage.setItem("orgLongName", data.orgLongName);
      this.appService.getUserDetailsForTrainingDashboard().subscribe((data: any) => {
        this.orgDetail1 = data[0];
        localStorage.setItem("timezone", this.orgDetail1.timezone);
        this.orgDetail1.timezone ??= "GMT";
        let dt = new Date();
        this.convertTZ(dt, this.orgDetail1.timezone);
      });

      //this.convertTZ(dt,this.appService.organizationDetails?.htmlDateFormat)
      this.SVC.permittedFileExtensions = this.SVC.organizationDetails.allowedFileExtns.split(',').map((fileExtension: any) => '.' + fileExtension).join(', ');
      this.SVC.logoutInMinutes = data.userSessionTimeoutInMins ?? 0;
      this.oneQmsAuthService.loginSuccess();
    })
    this.appService.getQmsSettingVw().subscribe((data: any) => {
      if (data != null) {
        this.SVC.qmsSettings = data;

        this.SVC.tabPagesOrderlist = data.tabPagesOrder?.split(",");
      }
    });
  };
  /*
    convertTZ(date: Date, timezone: any) {
      let dt = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: timezone }));
      let month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      let date2 = dt.getFullYear() + "-" + month_names[dt.getMonth()] + "-" + dt.getDate();
      let date1 = moment(date2).format(this.appService.organizationDetails?.htmlDateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.htmlDateFormat.toUpperCase());
      let hours = dt.getHours();
      let minutes: any = dt.getMinutes();
      let ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let strTime = hours + ':' + minutes + ' ' + ampm;
      let uiTime = document.getElementById('dateTime') as HTMLInputElement;
      uiTime && (uiTime.innerHTML = date1 + " " + strTime);

    } */

  convertTZ(date: Date | string, timezone: string) {
    const dt = new Date(
      (typeof date === 'string' ? new Date(date) : date)
        .toLocaleString('en-US', { timeZone: timezone })
    );

    const format =
      this.appService.organizationDetails?.htmlDateFormat
        ?.toUpperCase() || 'DD-MMM-YYYY';

    const date1 = moment(dt).format(format);

    const hours = String(dt.getHours()).padStart(2, '0');
    const minutes = String(dt.getMinutes()).padStart(2, '0');
    const seconds = String(dt.getSeconds()).padStart(2, '0');

    const uiTime = document.getElementById('dateTime') as HTMLElement;
    uiTime.innerHTML = `${date1} ${hours}:${minutes}:${seconds}`;
  }

  closesnackbar() {
    this.snackBar.dismiss();
  }

  @ViewChild('messageHistoryPopup', { static: true }) messageHistoryPopup: TemplateRef<any>;
  @ViewChild('uploadImagesPopup', { static: true }) uploadImagesPopup: TemplateRef<any>;
  @ViewChild('logoutPopup', { static: true }) logoutPopup: TemplateRef<any>;

  visibleMessageHistoryPopup: MatDialogRef<TemplateRef<any>>;
  visibleUploadImagesPopup: MatDialogRef<TemplateRef<any>>;
  visibleLogoutPopup: MatDialogRef<TemplateRef<any>>;

  messageHistoryPopupConfig = {
    width: 'auto',
    maxHeight: '400px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  uploadImagesPopupConfig = {
    width: '30%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  logmethod() {
    this.popupDataTitle.title = "Message History";
    this.visibleMessageHistoryPopup = this.dialog.open(this.messageHistoryPopup, this.messageHistoryPopupConfig);
  }
  oneQmsOrgImagesDetails: any = {};
  oneQmsOrgUsersDetails: any = {};
  getUserTimezoneDetails: any = {};
  dateAndTimeValues: any;
  orgDetail1: any = {};
  data1: any;
  public href: string = "";
  ngOnInit() {
    this.activatedRoute.data.subscribe(({ calendarEvent }) => {
      sessionStorage.setItem("calendarData", JSON.stringify(calendarEvent));
    })


    this.activatedRoute.data.subscribe(({ calendarDayEvent }) => {
      sessionStorage.setItem("todaysCount", JSON.stringify(calendarDayEvent));
    })


    this.activatedRoute.data.subscribe(({ orgDetails }) => {
      sessionStorage.setItem("orgDetails", JSON.stringify(orgDetails));
    })



    this.activatedRoute.data.subscribe(({ countries }) => {
      sessionStorage.setItem("dropDownForCountry", JSON.stringify(countries));
    })

    this.SVC.showSwitchUser = false;
    this.message.isAuditTrailUser = false;
    this.message.isDocumentDownloader = false;
    this.message.isTopicAdministrator = false;
    this.message.isTrainingGroupAdministrator = false;
    this.SVC.dataGridAdmin = false;


    this.message.breadcrumbData.fourthLevel = null;
    this.message.breadcrumbData.secondLevel = null;
    this.message.breadcrumbData.thirdLevel = null;
    this.authService.handleRedirectObservable()
      .pipe(
        filter((response) => response !== null && response.account !== null)
      )
      .subscribe((response) => {

      });

    if (localStorage.getItem("adEnabled") == "Y" && this.authService.instance.getAllAccounts().length == 0) {

      this.router.navigate(['/profile']);

    }

    this.SVC.showLeftMenu = 'Main';
    this.qmsservice.userModuleList = [];
    this.qmsservice.moduleName = null;
    let d = new Date();
    this.dateAndTimeValues = d.toString();

    this.appService.getUserTimezoneDetails().subscribe((response: any) => {
      this.getUserTimezoneDetails = response;
      sessionStorage.setItem('getUserTimezoneDetails', JSON.stringify(response));
    })

    this.appService.getAllOrgReportImages().subscribe((response1: any) => {
      this.oneQmsOrgImagesDetails = response1;
    })

    this.appService.getOneQmsUserDetails().subscribe((response: any) => {
      this.oneQmsOrgUsersDetails = response;
      this.qmsservice.getOneQmsOrgUsersDetails = response;
      sessionStorage.setItem('oneQmsOrgUsersDetails', JSON.stringify(response));
    })

    this.appService.getCodeListsByGroup("DESIGNATION").subscribe((response1: any) => {
      sessionStorage.setItem('dropDownForDesignationCode', JSON.stringify(response1));
    })

    this.appService.getCodeListsByGroup("DEPARTMENT").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForDepartmentCode', JSON.stringify(response));
    })

    this.appService.getCodeListsByGroup("TRAINING_LANGUAGE").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForPrimaryLanguage', JSON.stringify(response));
    })

    this.appService.getCodeListsByGroup("USER_LANGUAGE").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForPrimaryLanguage', JSON.stringify(response));
    });

    this.appService.getCodeListsByGroup("TRAINING_CATEGORY").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForTrainingCategory', JSON.stringify(response));
    })

    this.appService.getNonOrgCodeListsByGroupName("USER_NAME_FORMAT").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForUserNameFormat', JSON.stringify(response));
    })

    this.appService.getNonOrgCodeListsByGroupName("OOS_OOT_TYPE").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForOosType', JSON.stringify(response));
    })

    this.appService.getNonOrgCodeListsByGroupName("PDF_PAGE_SIZE").subscribe((response: any) => {
      sessionStorage.setItem('pdfPageSizes', JSON.stringify(response));
    });

    this.appService.getNonOrgCodeListsByGroupName("DATE_FORMAT").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForDateFormat', JSON.stringify(response));
    });

    this.appService.getNonOrgCodeListsByGroupName("REPORTS_TIMEZONE").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForReportTimezone', JSON.stringify(response));
    })

    this.appService.getTimezoneListDetails().subscribe((response: any) => {
      sessionStorage.setItem('dropDownForTimezone', JSON.stringify(response));
    });


    this.appService.getNonOrgCodeListsByGroupName("TRAINING_CATEGORY_SUBGROUP").subscribe((response: any) => {
      sessionStorage.setItem('TrainingCategorySubgroups', JSON.stringify(response));
    });


    this.appService.nonorgModules().subscribe((response: any) => {
      sessionStorage.setItem('nonorgModulesData', JSON.stringify(response));
    });


    this.appService.nonorgModuleprivs().subscribe((response: any) => {
      sessionStorage.setItem('nonorgModulePrivssData', JSON.stringify(response));
    });


    this.appService.getCodeListsmoduleByGroup("MODULES").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForModules', JSON.stringify(response));
    });

    this.appService.getCodeListsByGroup("ACTIVITY_INITIATED_AT").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForRequestedAt', JSON.stringify(response));
    });


    this.appService.getCodeListsByGroup("REASON_FOR_CHANGE").subscribe((response: any) => {
      sessionStorage.setItem('dropDownForReasonForChange', JSON.stringify(response));
    });

    this.appService.getNonOrgCodeListsByGroupName("CR_STATUS").subscribe((response: any) => {
      sessionStorage.setItem('crStatus', JSON.stringify(response));
    })
    this.appService.getNonOrgCodeListsByGroupName("CAPA_STATUS").subscribe((response: any) => {
      sessionStorage.setItem('capaStatus', JSON.stringify(response));
    })

    this.appService.getNonOrgCodeListsByGroupName("CC_STATUS").subscribe((response: any) => {
      sessionStorage.setItem('ccStatus', JSON.stringify(response));
    })
    this.appService.getNonOrgCodeListsByGroupName("DV_STATUS").subscribe((response: any) => {
      sessionStorage.setItem('dvStatus', JSON.stringify(response));
    })
    this.appService.getNonOrgCodeListsByGroupName("QI_STATUS").subscribe((response: any) => {
      sessionStorage.setItem('qiStatus', JSON.stringify(response));
    })
    this.appService.getNonOrgCodeListsByGroupName("IN_STATUS").subscribe((response: any) => {
      sessionStorage.setItem('inStatus', JSON.stringify(response));
    })
    this.appService.getNonOrgCodeListsByGroupName("OOS_STATUS").subscribe((response: any) => {
      sessionStorage.setItem('oosStatus', JSON.stringify(response));
    })
    this.appService.getNonOrgCodeListsByGroupName("AU_STATUS").subscribe((response: any) => {
      sessionStorage.setItem('auStatus', JSON.stringify(response));
    })

    this.appService.getNonOrgCodeListsByGroupName("EXPIRY_UNIT").subscribe((response: any) => {
      sessionStorage.setItem('expiryUnits', JSON.stringify(response));
    })


    this.appService.getNonOrgCodeListsByGroupName("DOC_TYPE_CR_PROCESS").subscribe((response: any) => {
      sessionStorage.setItem('docTypeCRProcess', JSON.stringify(response));
    });
    this.appService.userPrivsDetails(this.message.getUserId()).subscribe((response: any = {}) => {
      if (response) {
        this.SVC.showSwitchUser = response.funcRoles?.includes("Switch User");
        this.message.isAuditTrailUser = response.funcRoles?.includes("Audit Trail User");
        this.message.isDocumentDownloader = response.funcRoles?.includes("Document Downloader");
        this.message.isTopicAdministrator = response.funcRoles?.includes("Topic Administrator")
        this.message.isPrintAdministrator = response.funcRoles?.includes("Printer Administrator")
        this.SVC.dataGridAdmin = response.funcRoles?.includes("Data Grid Administrator");
        this.message.isTrainingGroupAdministrator = response.trainingUserRoles?.includes("Training Group Administrator");
        this.message.isTrainingAdministrator = response.trainingUserRoles?.includes("Training Administrator");
      }
    });
  }


  searchIcon = faSearch;
  faHamburger = faHamburger;
  faDedent = faDedent;

  userIcon = faUser;
  HomeIcon = faHome;
  SquareEnvelopeIcon = faSquareEnvelope;
  CircleQuestionIcon = faCircleQuestion;
  SignOutIcon = faSignOut;
  MessageIcon = faMessage;

  left_nav_lis_item: Array<{ title: string; icon: any, url: string }> = [
    {
      title: "books",
      icon: faBook,
      url: 'table'
    },
    {
      title: "Users",
      icon: faUser,
      url: 'user'
    },
    {
      title: "test1",
      icon: faTrowel,
      url: 'test1'
    },
    {
      title: "test2",
      icon: faAmbulance,
      url: 'test2'
    },
    {
      title: "test3",
      icon: faAnchorCircleCheck,
      url: 'test3'
    },
  ];

  showLeftNav: boolean = false;
  public onChange: EventEmitter<any> = new EventEmitter<any>();

  public doSomething(message: boolean) {
    // do something, then...
    this.onChange.emit(message);
  }

  showAndHideLeftNav() {
    this.showLeftNav = !this.showLeftNav;
    this.doSomething(this.showLeftNav);
  }

  logout() {
    this.popupDataTitle.title = "Confirm";
    this.visibleLogoutPopup = this.dialog.open(this.logoutPopup, this.uploadImagesPopupConfig);
  }

  cancelLogoutPopupFunction() {
    this.visibleLogoutPopup.close();
  }

  homepage() {
    this.message.breadcrumbData = {};
    this.SVC.showLeftMenu = "Main";

    this.router.navigate(['dashboard']);
  }

  popupDataTitle: PopupData = {
    title: ''
  };

  imageUploadFlag: any;
  uploadInputFiledValue: any;

  openUserImageUploadPopup() {
    this.popupDataTitle.title = "User Profile";
    this.imageUploadFlag = "User";
    this.visibleUploadImagesPopup = this.dialog.open(this.uploadImagesPopup, this.uploadImagesPopupConfig);
  }

  imageToUpload: File | null = null;
  imageExtention: any;
  uploadSuccessMsg: any;
  uploadSuccessIcon: any;
  uploadErrorMsg: any;
  uploadErrorIcon: any;
  uploadRequiredMsg: any;
  uploadRequiredIcon: any;

  uploadImages(e: any) {
    this.imageToUpload = e.target.files[0];
    this.imageExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();

    this.uploadSuccessMsg = document.getElementById('logo-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('logo-success-icon') as HTMLInputElement;

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;

    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    if (this.imageExtention != "jpg" && this.imageExtention != "png" && this.imageExtention != "jpeg") {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';

      this.uploadErrorMsg.style.display = 'block';
      this.uploadErrorIcon.style.display = 'block';

      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';
    } else {
      this.uploadSuccessMsg.style.display = 'block';
      this.uploadSuccessIcon.style.display = 'block';

      this.uploadErrorMsg.style.display = 'none';
      this.uploadErrorIcon.style.display = 'none';

      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';
    }

    const file: File = e.target.files[0];

    if (file) {
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "IMAGE");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") { /* empty */ } else {
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        })
    }
  }

  uploadImagesValidation() {
    this.uploadSuccessMsg = document.getElementById('logo-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('logo-success-icon') as HTMLInputElement;

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;

    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    if (this.imageToUpload == null || this.imageToUpload == undefined) {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';

      this.uploadErrorMsg.style.display = 'none';
      this.uploadErrorIcon.style.display = 'none';

      this.uploadRequiredMsg.style.display = 'block';
      this.uploadRequiredIcon.style.display = 'block';
    }
  }

  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  dataValues: any = {};

  uploadLogoImage() {
    this.isProcessing = true;
    if (this.imageToUpload == null || this.imageToUpload == undefined) {
      this.uploadImagesValidation();
      this.isProcessing = false;
    } else if (this.imageUploadFlag == "Organization") {
      if (this.oneQmsOrgImagesDetails != null || this.oneQmsOrgImagesDetails != undefined) {
        this.dataValues = {
          operation: 'U',
          logoImageExt: this.imageExtention
        };
        const uploadLogoData = new FormData();
        uploadLogoData.append('binaryLogoFile', this.imageToUpload ?? '');
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        uploadLogoData.append('oneQmsOrgImagesDto', blob);
        this.appService.updateLogoImage(uploadLogoData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.isProcessing = false;
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
            this.ngOnInit();
            this.visibleUploadImagesPopup.close();
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        this.dataValues = {
          operation: 'I',
          logoImageExt: this.imageExtention
        };
        const addLogoData = new FormData();
        addLogoData.append('binaryLogoFile', this.imageToUpload ?? '');
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        addLogoData.append('oneQmsOrgImagesDto', blob);
        this.appService.addLogoImage(addLogoData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.isProcessing = false;
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
            this.ngOnInit();
            this.visibleUploadImagesPopup.close();
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }
    } else if (this.oneQmsOrgUsersDetails != null || this.oneQmsOrgUsersDetails != undefined) {
      this.dataValues = {
        operation: 'U',
        userImageExtn: this.oneQmsOrgUsersDetails.imageExtention
      };
      const uploadLogoData = new FormData();
      uploadLogoData.append('binaryLoginFile', this.imageToUpload ?? '');
      const json = JSON.stringify(this.dataValues);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      uploadLogoData.append('oneQmsUserDetailsDto', blob);
      this.appService.updateUserImage(uploadLogoData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
          this.ngOnInit();
          this.visibleUploadImagesPopup.close();
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.dataValues = {
        operation: 'I',
        userImageExtn: this.imageExtention
      };
      const addLogoData = new FormData();
      addLogoData.append('binaryLoginFile', this.imageToUpload ?? '');
      const json = JSON.stringify(this.dataValues);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      addLogoData.append('oneQmsUserDetailsDto', blob);
      this.appService.addUserImage(addLogoData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
          this.ngOnInit();
          this.visibleUploadImagesPopup.close();
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelUploadLogoFunction() {
    this.imageToUpload = null;
    this.visibleUploadImagesPopup.close();
  }

  cancelMessageHistoryFunction() {
    this.visibleMessageHistoryPopup.close();
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true,
  };
  messageCount: any;
  openTopicPopup() {
    this.SVC.communicatingFrom = 'Dashboard';
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  canceltopicPopup() {
    this.visibleTopicPopup.close();
    this.isProcessing = true;
    this.appService.getOneQmsReceivedTopics().subscribe((response: any) => {
      const topicsData = response;
      this.messageCount = 0;
      for (const topic of topicsData) {
        topic.readAlready == "N" && this.messageCount++;
      }
      this.messageCount = this.messageCount > 99 ? "99+" : this.messageCount;
      this.isProcessing = false;
    })
  }

  isMobileOrTablet: boolean = false;
  detectDevice(): void {
    const ua = navigator.userAgent.toLowerCase(); // only userAgent
    const width = window.innerWidth;

    // Detect mobile/tablet via userAgent
    const isMobileUA = /iphone|ipod|android.*mobile|windows phone|blackberry|opera mini|mobile/i.test(ua);
    const isTabletUA = /ipad|android(?!.*mobile)|tablet/i.test(ua);

    // Fallback: screen width (for Desktop site override)
    const isSmallScreen = width <= 1024; // treat widths <=1024px as tablet/mobile

    this.isMobileOrTablet = isMobileUA || isTabletUA || isSmallScreen;

    // Block scroll if mobile/tablet
    document.body.style.overflow = this.isMobileOrTablet ? 'hidden' : 'auto';
  }

  triggerLogout(from?: string) {
    this.oneQmsAuthService.logout(from);
  }

}
